import FilterHelper from './FilterHelper';

type Operators = 'equals' | 'greaterThan' | 'lessThan' | 'notEquals' | 'between';

class NumberFilterHelper extends FilterHelper {
  value = -1;

  value2 = -1;

  operator: Operators = 'equals';

  constructor(val: number, operator: Operators = 'equals', val2: number = -1) {
    super();
    this.value = val;
    this.value2 = val2;
    this.operator = operator;
  }

  // eslint-disable-next-line class-methods-use-this
  getResult(): string {
    switch (this.operator) {
      case 'greaterThan':
        return `>${this.value.toFixed(6)}`;
      case 'lessThan':
        return `<${this.value.toFixed(6)}`;
      case 'notEquals':
        return `!${this.value.toFixed(6)}`;
      case 'between':
        return `${this.value.toFixed(6)}...${this.value2.toFixed(6)}`;
      default:
        return this.value.toFixed(6);
    }
  }
}

export const greaterThan = (val: number) => new NumberFilterHelper(val, 'greaterThan');

export const lessThan = (val: number) => new NumberFilterHelper(val, 'lessThan');

export const equals = (val: number) => new NumberFilterHelper(val, 'equals');

export const notEquals = (val: number) => new NumberFilterHelper(val, 'notEquals');

export const between = (val: number, val2: number) => new NumberFilterHelper(val, 'between', val2);
